"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/Button";

// Route-level error boundary per Next.js App Router conventions.
// Replaces the default "This page couldn't load" generic error UI with a
// branded retry surface. Errors from transient Sanity fetches, RSC chunk
// failures, or hydration mismatches are caught here.
export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface to Vercel function logs (visible via `vercel logs`).
    console.error("Route error caught:", error.message, error.digest);
  }, [error]);

  return (
    <main className="flex min-h-[80vh] items-center justify-center px-6">
      <div className="mx-auto max-w-md text-center">
        <p className="font-display text-xs uppercase tracking-[0.3em] text-gold">
          Something went sideways
        </p>
        <h1 className="mt-4 font-display text-4xl tracking-tight text-fg">
          We hit a snag loading this page.
        </h1>
        <p className="mt-6 font-body text-base text-fg-muted">
          Try again, it&apos;s usually a quick blip on first navigation.
        </p>
        <div className="mt-10 flex items-center justify-center gap-4">
          <button
            type="button"
            onClick={reset}
            className="inline-block rounded-sm bg-gold px-8 py-3 font-body text-sm uppercase tracking-wider text-black transition-colors hover:bg-gold-bright"
          >
            Try again
          </button>
          <Button variant="gold-outline" size="md" href="/">
            Home
          </Button>
        </div>
        {error.digest ? (
          <p className="mt-8 font-body text-xs text-fg-faint">
            Reference: <code className="font-mono">{error.digest}</code>
          </p>
        ) : null}
      </div>
    </main>
  );
}
